import {Navigate,useLocation} from 'react-router-dom'
import {useAuth} from '../contexts/AuthContext'
import LoadingSpinner from './LoadingSpinner'

export default function ProtectedRoute({children}){
 const {user,isInitialized}=useAuth()
 const location=useLocation()
 if(!isInitialized)return <div className="p-8 flex justify-center"><LoadingSpinner/></div>
 if(!user)return <Navigate to="/login" state={{from:location.pathname}} replace/>
 return children
}
